module.exports = __webpack_public_path__ + "static/media/usb@2x.e8e0b054.png";